module.exports = __webpack_public_path__ + "media/images/audio-waves-ffdeb36dbb80af10f77b8802eb0832c4d470f93074a0a66fdb3c1d143b82c732.svg";